import React from "react";
import { Box } from "@mui/material";
import Layout from "../Layout";
import Welcome from "../../../widgets/operator/Welcome/index.jsx";
import ComboDays from "../../../widgets/operator/dashboard/ComboDays";
import Earnings from "../../../widgets/operator/dashboard/Earnings";
import Payments from "../../../widgets/operator/dashboard/Payments";
import WorkChart from "../../../widgets/operator/dashboard/WorkChart";
import RatingTable from "../../../widgets/operator/dashboard/RatingTable";
import CrmTable from "../../../widgets/operator/dashboard/CrmTable";
import OperatorStats from "../../../widgets/operator/dashboard/OperatorStats";
import { welcomeData } from "../../../data/operator/dashboard/welcome";

import { periodOptions } from "../../../data/operator/dashboard/ratingData";

import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth.js";
import { paymentsInfo } from "../../../data/operator/dashboard/payments.js";

const Dashboard = () => {
  const { data, loading, error } = useFetchWithAuth("/user/me/");

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!data) return null;
  return (
    <Layout>
      <Box sx={{ p: 3, width: "100%", mx: "auto" }}>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Box sx={{ flex: 2, minWidth: 0 }}>
            <Welcome data={{ ...welcomeData, first_name: data.first_name }} />
          </Box>
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <ComboDays />
            <Earnings />
            <OperatorStats />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Box sx={{ flex: 2, minWidth: 0 }}>
            <Payments
              data={{
                ...paymentsInfo,
                salary_amount: data.salary_amount,
                salary_date: data.salary_date,
              }}
            />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <WorkChart userId={data.id} />
          </Box>
        </Box>
        <RatingTable periodOptions={periodOptions} />
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <CrmTable />
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default Dashboard;
